import { cx } from './ui'

/**
 * The mark is a target reticle with the cross-hair broken open on one side -
 * a click point that is also a link. It reads at 20px in a header and at 96px
 * on the sign-in screen without a second asset.
 */
export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="2" strokeOpacity="0.28" />
      <path
        d="M16 3a13 13 0 0 1 11.26 6.5"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <circle cx="16" cy="16" r="5.5" stroke="currentColor" strokeWidth="2.4" />
      <circle cx="16" cy="16" r="1.9" fill="currentColor" />
    </svg>
  )
}

export function Logo({
  size = 'md',
  className,
  wordmark = 'always',
}: {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /**
   * `'sm'` drops the word and keeps the mark on phone-width screens.
   *
   * The mark alone still reads as the brand, and in a header the wordmark is
   * the first thing worth giving up: it costs 109px, which on a 360px screen
   * is the difference between the controls on the right fitting and being
   * pushed off the edge.
   */
  wordmark?: 'always' | 'sm'
}) {
  const config = {
    sm: { mark: 22, text: 'text-[0.8125rem]' },
    md: { mark: 28, text: 'text-base' },
    lg: { mark: 44, text: 'text-2xl sm:text-3xl' },
  }[size]

  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={config.mark} className="shrink-0 text-lime" />
      <span
        className={cx(
          'display-title leading-none',
          config.text,
          wordmark === 'sm' && 'hidden sm:inline',
        )}
      >
        <span className="text-fg">Click</span>
        <span className="text-lime">linx</span>
      </span>
    </span>
  )
}
